import $ from "jquery";
import React, { Suspense, useContext, useEffect, useState } from 'react';

import UserBasicInfoQRContext from "./../../../components/Context/UserBasicInfoQRContext";
import ClearanceHistory from "./ClearanceHistory";
import SettlementProcess from "./SettlementProcess";
import SettlementComplete from "./SettlementComplete";

import init from "../AccessControl/Check";



const Settlement = () => {

    const settlementProcessAccess = init("Settlement Process");
    const settlementCompleteAccess = init("Settlement Complete");

    const companyInfo = useContext(UserBasicInfoQRContext);

    const [currentTab, setCurrentTab] = useState("clearance-history");
    const handleTab = (tabId, event) => {
        $(".tablinks").removeClass("current");
        $(event.target).addClass("current");
        setCurrentTab(tabId);
    }


    return (
        <div className="custom-container w-full float-left px-8 py-10 pt-4 block font-montserrat custom-scroll-auto mb-20">

            {(companyInfo?.id === null || companyInfo?.id === "" || companyInfo?.id === undefined) ?
                <table className="custom-details-table w-full mt-0 mb-2">
                    <tbody>
                        <tr>
                            <td className="font-semibold text-base">
                                Before proceeding, please select a company.
                            </td>
                        </tr>
                    </tbody>
                </table>
                :
                <>

                    <div className="tab ">
                        <button className="tablinks current" onClick={(event) => handleTab("clearance-history", event)}>&nbsp;Clearance History</button>

                        {(settlementProcessAccess) && 
                            <button className="tablinks" onClick={(event) => handleTab("settlement-process", event)}>&nbsp;&nbsp;Settlement Process</button>
                        }

                        {(settlementCompleteAccess) && 
                            <button className="tablinks" onClick={(event) => handleTab("settlement-confirm", event)}>&nbsp;&nbsp;Settlement Confirm</button>
                        }
                        
                    </div>


                    <div className='tabcontentbody py-3 px-0'>
                        <div id="view-profile" className="tabcontent" style={{ display: "block", paddingInline: "0px" }}>
                            <Suspense fallback="Loading...">
                                {(() => {
                                    switch (currentTab) {
                                        case "clearance-history":
                                            return <ClearanceHistory />;
                                        case "settlement-process":
                                            return <SettlementProcess />;
                                        case "settlement-confirm":
                                            return  <SettlementComplete />;
                                        default:
                                            return <h1>No page found.</h1>;
                                    }
                                })()}
                            </Suspense>
                        </div>
                    </div>
                </>
            }

        </div>
    )
}


export default Settlement;
